<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import type { DayRedBlackResponse } from '~/server/types'
import { formatRedBlankData } from '~/shared/function'

const props = withDefaults(defineProps<{
  data: DayRedBlackResponse
}>(), {

})
const itemKeyList = ['red', 'black']
const dayItem = computed(() => formatRedBlankData(props.data))
</script>

<template>
  <div class="flex red-black border-1 border-slate-2">
    <div v-for="(v, i) in itemKeyList" :key="i" class="border-r-1 border-slate-2 last:border-r-0 flex-grow min-w-0 w-50% flex-shrink-0">
      <template v-if="dayItem && Object.keys(dayItem).includes(v) && dayItem[v]">
        <RedBlackDayItem :item="dayItem[v]" :type="!i ? 'red' : 'black'" />
      </template>
    </div>
  </div>
  <slot name="button">
    <NuxtLink :to="APP_ROUTER.newsDetail(data.articleId)" class="block text-center leading-3.8em text-3.5" target="_blank">
      查看详情
    </NuxtLink>
  </slot>
</template>

<style lang='scss' scoped>
.red-black-item {
  padding-left: 70px;
  width: 600px;

  &:last-child {
    padding-left: 50px;
  }

  &__info {
    &>div {
      width: 25%;
    }
  }
}
</style>
